import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';

import { ToggleButton, Typography } from '../../../../components/atoms';
import { EditOutlined as EditOutlinedIcon } from '../../../../components/icons';

const useStyles = makeStyles((theme: Theme) => ({
  customTipLabel: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(0.5),
  },
  customTipLabelText: {
    marginRight: theme.spacing(0.5),
  },
  customTipLabelIcon: {
    alignSelf: 'center',
  },
}));

export type CustomTipOptionProps = {
  className: string;
  customTipAmountLabel: string;
  hasCustomTip: boolean;
  toggleCustomTipInput: () => void;
  translate: any;
};

export function CustomTipOption(props: CustomTipOptionProps): JSX.Element {
  const {
    className,
    customTipAmountLabel,
    hasCustomTip,
    toggleCustomTipInput,
    translate,
  } = props;
  const classes = useStyles();

  return (
    <ToggleButton
      className={className}
      data-fd="custom-tip-option-button"
      onClick={toggleCustomTipInput}
      selected={hasCustomTip}
      value={customTipAmountLabel}
    >
      <div>
        <Typography>
          <strong>{translate('Tipping_CustomTip_description')}</strong>
        </Typography>

        <div className={classes.customTipLabel}>
          {hasCustomTip && (
            <Typography className={classes.customTipLabelText}>
              {customTipAmountLabel}
            </Typography>
          )}
          <EditOutlinedIcon size="xs" className={classes.customTipLabelIcon} />
        </div>
      </div>
    </ToggleButton>
  );
}
